import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PlaceHolder from "../../../../assets/images/Placeholder.png";
import {
  MessageStatusUpdate,
  NegotiateOffer,
} from "../../../../components/Header/Data";
import {
  Dialog,
  DialogContent,
  Button,
  TextField,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ScheduleCallModal from "./ScheduleCallModal";
import CallDetailsModal from "./CallDetailsModal";
import { updateSelectedConvoFields } from "../../../../redux/slices/MsgSlice";

const OfferDetailsModal = ({
  isOpen,
  closeModal,
  negotiate,
  setNegotiate,
  accept,
  setAccept,
  msg,
}) => {
  const dispatch = useDispatch();
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [message, setMessage] = useState("");
  const [budget, setBudget] = useState(null);
  const [reject, setReject] = useState(false);
  const [explore, setExplore] = useState(false);
  const [openCall, setOpenCall] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [reSchedule, setReSchedule] = useState(false);
  const [missedCall, setMissedCall] = useState(false);
  const navigate = useNavigate();

  const handleAcceptOffer = async () => {
    const status = {
      messageStatus: msg.ownerId === user.UserID ? 4 : 9,
      updatedBy: user.UserID,
      Email: user.Email,
      parentId: msg?.parentId,
      needOwnerId: msg?.ownerId,
      finalBudget: msg?.finalBudget,
      id: msg?.Id,
      messageComment: message,
      serviceNeed: "need",
      ownerId: msg?.ownerId,
      postId: msg?.postId,
      customerId: msg?.customerId,
      createdBy: msg.createdBy,
    };
    await MessageStatusUpdate(status, msg?.Id);
    dispatch(
      updateSelectedConvoFields({
        messageStatus: status.messageStatus,
        messageComment: status.messageComment,
      })
    );
    toast.success("Offer Accepted");
    setAccept(false);
    setMessage("");
    closeModal();
  };

  const AcceptToggle = (event) => {
    event.stopPropagation();
    setAccept(true);
  };

  const handleClick = (e) => {
    const offerAmount = msg.finalBudget !== null ? msg.finalBudget : 0;
    e.stopPropagation();
    if (islogin) {
      navigate("/order-summary", {
        state: { msg, offerAmount },
      });
    } else {
      navigate("/login");
      toast.info("Please Login");
    }
  };

  const RejectToggle = (event) => {
    event.stopPropagation();
    setReject(true);
  };

  const handleRejectOffer = async () => {
    const status = {
      id: msg?.Id,
      messageStatus: msg.ownerId === user.UserID ? 5 : 10,
      updatedBy: user.UserID,
      Email: user.Email,
      needOwnerId: msg?.ownerId,
      finalBudget: msg?.finalBudget,
      serviceNeed: "need",
      ownerId: msg?.ownerId,
      postId: msg?.postId,
      customerId: msg?.customerId,
      messageComment: message,
      createdBy: msg.createdBy,
    };
    if (!status.messageComment) {
      toast.error("Enter Message");
      return;
    }
    await MessageStatusUpdate(status, msg?.Id);
    dispatch(
      updateSelectedConvoFields({
        messageStatus: status.messageStatus,
        messageComment: status.messageComment,
      })
    );
    closeModal();
    setReject(false);
    toast.success("Offer Rejected");
    setMessage("");
  };

  const handlebudget = (e) => {
    let value = e.target.value.replace(/[^0-9.]/g, "");
    const decimalCount = (value.match(/\./g) || []).length;
    if (decimalCount > 1) {
      value = value.substring(0, value.lastIndexOf("."));
    }
    if (value.length <= 6) {
      const parts = value.split(".");
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, 2);
        value = parts.join(".");
      }
      setBudget(value || null);
    }
  };

  const handleNegociateOffer = async () => {
    const negot = {
      Id: msg?.Id,
      customerId: msg?.createdBy,
      postId: msg?.postId,
      postType: 3,
      Description: message,
      Email: user.Email,
      messageStatus: msg.ownerId !== user.UserID ? 7 : 6,
      createdBy: user.UserID,
      roleId: user.RoleId,
      ownerId: msg?.ownerId,
      Budget: budget,
      finalBudget: budget,
      needId: msg?.postId,
      needName: msg?.postName,
      updatedBy: user.UserID,
      userName: user.UserName.split("@")[0].trim(),
      serviceNeed: "need",
      parentId: msg?.parentId == 0 ? msg?.Id : msg?.parentId,
    };
    if (!budget) {
      toast.error("Enter Budget");
      return;
    } else if (!message) {
      toast.error("Enter Message");
      return;
    }
    await NegotiateOffer(negot);
    closeModal();
    toast.success(`Sent Negotiation to ${budget}`);
    setBudget(null);
    setMessage("");
  };

  const negotiateClick = (e) => {
    e.stopPropagation();
    setNegotiate(true);
  };

  const GoBackNego = (e) => {
    e.stopPropagation();
    setNegotiate(false);
  };

  useEffect(() => {
    setBudget("");
    setMessage("");
    setAccept(false);
    setExplore(false);
    setReject(false);
  }, []);

  const closeModalhere = () => {
    closeModal();
    setExplore(false);
    setBudget(null);
    setMessage("");
    setAccept(false);
    setNegotiate(false);
    setReject(false);
  };

  const handleCallModal = () => {
    closeModal();
    setOpenCall(true);
    setExplore(false);
  };

  const handleDetailsModal = () => {
    closeModal();
    setOpenDetails(true);
    setExplore(false);
  };

  console.log(msg, "msg");

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={() => {
          closeModal();
          setBudget(null);
          setMessage("");
          setExplore(false);
          setAccept(false);
          setNegotiate(false);
          setReject(false);
        }}
        PaperProps={{
          className:
            " rounded-2xl p-10 max-h-[80vh] overflow-y-auto w-1/2 mx-auto border border-gray-300",
        }}
      >
        <DialogContent className="relative">
          <Box className="d-flex justify-content-end">
            <IconButton onClick={closeModalhere}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box className="position-relative">
            {msg && !negotiate && !accept && !reject ? (
              <Box>
                <Box className="absolute -top-20 d-flex items-center gap-4">
                  {/* <img className="h-16 w-16 rounded-full" /> */}
                  <img
                    src={
                      msg?.createdBy === user?.UserID
                        ? msg?.receiverProfilePhoto === ""
                          ? PlaceHolder
                          : msg?.receiverProfilePhoto
                        : msg?.senderPhoto === ""
                        ? PlaceHolder
                        : msg?.senderPhoto
                    }
                    alt={
                      msg?.createdBy === user?.UserID
                        ? msg?.userName.split("@")[0].trim()
                        : msg?.senderName
                    }
                    className="rounded-circle mb-2"
                    width={50}
                    height={50}
                  />
                  <Typography variant="h5" className="mt-2">
                    {msg?.createdBy === user?.UserID
                      ? msg?.userName.split("@")[0].trim()
                      : msg?.senderName}
                  </Typography>
                </Box>
                <Box className="mt-16">
                  <Typography className="text-center text-gray-800">
                    We recommend to speak to the vendor & reach an agreement of
                    terms before “Accepting the offer”
                  </Typography>
                  <Box className="mb-4">
                    <Typography className="mb-2">Offer Details</Typography>
                    <Box className="flex items-center p-2 border border-gray-300 rounded">
                      <Typography>{msg?.Message}</Typography>
                    </Box>
                  </Box>
                  <Box>
                    <Typography className="mb-2">Price</Typography>
                    <Box className="flex items-center p-2 border border-gray-300 rounded">
                      <Typography>$ {msg?.finalBudget}</Typography>
                    </Box>
                  </Box>
                </Box>
                {explore && (
                  <Box className="text-center m-3">
                    {msg?.zoomStatus === 0 ? (
                      <Typography className="text-left text-gray-800">
                        A call with{" "}
                        {msg?.ownerId === user.UserID ? "vendor" : "customer"}{" "}
                        has not been scheduled yet, please click on{" "}
                        <Button
                          variant="contained"
                          size="small"
                          onClick={handleCallModal}
                          className="mx-1"
                        >
                          Schedule a Call
                        </Button>{" "}
                        to speak with vendor
                      </Typography>
                    ) : (
                      <Typography className="text-left text-gray-800">
                        A call has been scheduled with{" "}
                        {msg?.ownerId === user.UserID ? "vendor" : "customer"}{" "}
                        already, please click on{" "}
                        <Button
                          variant="contained"
                          size="small"
                          onClick={handleDetailsModal}
                          className="mx-1"
                        >
                          View Details
                        </Button>{" "}
                        or{" "}
                        <Button
                          variant="contained"
                          color="error"
                          size="small"
                          onClick={RejectToggle}
                          className="mx-1"
                        >
                          Reject
                        </Button>{" "}
                        the Offer
                      </Typography>
                    )}
                  </Box>
                )}
                <Box className="d-flex justify-content-end mt-3 gap-1">
                  {msg?.zoomStatus === 6 &&
                    (msg?.messageStatus === 3 || msg?.messageStatus === 11) && (
                      <Button
                        variant="outlined"
                        color="success"
                        onClick={AcceptToggle}
                      >
                        Accept
                      </Button>
                    )}
                  {(msg?.messageStatus === 4 || msg?.messageStatus === 9) &&
                    msg?.ownerId === user.UserID && (
                      <Button
                        variant="contained"
                        color="success"
                        onClick={handleClick}
                        className="px-4"
                      >
                        Proceed To Pay
                      </Button>
                    )}
                  {msg?.zoomStatus !== 6 && (
                    <>
                      {!explore && (
                        <Button
                          variant="contained"
                          color="success"
                          onClick={() => setExplore(true)}
                          disabled={explore}
                        >
                          Explore Further
                        </Button>
                      )}
                    </>
                  )}
                  {msg?.zoomStatus === 6 &&
                    (msg?.messageStatus === 3 || msg?.messageStatus === 11) && (
                      <>
                        <Button
                          variant="outlined"
                          color="error"
                          onClick={RejectToggle}
                        >
                          Reject
                        </Button>
                        <Button
                          variant="outlined"
                          color="warning"
                          onClick={negotiateClick}
                        >
                          Negotiate
                        </Button>
                      </>
                    )}
                </Box>
              </Box>
            ) : !negotiate && accept ? (
              <Box>
                <Typography variant="h5" className="text-center">
                  Accepting Offer
                </Typography>
                <Box className="text-center p-2">
                  <Typography component="span" fontWeight="bold">
                    Before you accept the offer or proceed with payment, please
                    make sure you have discussed all deal terms with the site
                    inbox section to document all details of the deal
                  </Typography>
                </Box>
                <Box className="flex justify-end items-center mt-3 gap-2">
                  <Button
                    variant="contained"
                    color="success"
                    onClick={handleAcceptOffer}
                  >
                    Accept Offer
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => setAccept(false)}
                  >
                    Go Back
                  </Button>
                </Box>
              </Box>
            ) : !negotiate && reject ? (
              <Box>
                <Typography variant="h5" className="text-center">
                  Rejecting Offer
                </Typography>
                <Box className="mt-4">
                  <Typography>
                    Message <span className="text-red-500">*</span>
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    placeholder="Please explain why you are rejecting the offer..."
                    onChange={(e) => setMessage(e.target.value)}
                    className="mt-2"
                  />
                </Box>
                <Box className="flex justify-end items-center mt-3 gap-2">
                  <Button
                    variant="contained"
                    onClick={handleRejectOffer}
                    sx={{ backgroundColor: "#A2D4ED" }}
                  >
                    Reject Offer
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => setReject(false)}
                  >
                    Go Back
                  </Button>
                </Box>
              </Box>
            ) : (
              <Box className="relative">
                <Box className="absolute -top-20 flex items-center justify-center gap-4">
                  <img
                    src={
                      msg?.createdBy === user?.UserID
                        ? msg?.receiverProfilePhoto === ""
                          ? PlaceHolder
                          : msg?.receiverProfilePhoto
                        : msg?.senderPhoto === ""
                        ? PlaceHolder
                        : msg?.senderPhoto
                    }
                    alt={
                      msg?.createdBy === user?.UserID
                        ? msg?.userName.split("@")[0].trim()
                        : msg?.senderName
                    }
                    className="h-16 w-16 rounded-full"
                  />
                  <Typography variant="h5" className="mt-2">
                    {msg?.createdBy === user?.UserID
                      ? msg?.userName.split("@")[0].trim()
                      : msg?.senderName}
                  </Typography>
                </Box>
                <Box className="mt-16">
                  <Box>
                    <Typography>
                      Package price <span className="text-red-500">*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      type="number"
                      placeholder="$00.00"
                      onChange={handlebudget}
                      className="mt-2"
                    />
                  </Box>
                  {msg?.ownerId === user.UserID &&
                    budget &&
                    budget < msg.finalBudget * 0.9 && (
                      <Typography className="text-red-500 mt-2">
                        You may not suggest prices exceeding 10% price drop from
                        the initial offer ({msg.finalBudget})
                      </Typography>
                    )}
                  <Box className="mt-4">
                    <Typography>
                      Message <span className="text-red-500">*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                      placeholder="Type message.."
                      onChange={(e) => setMessage(e.target.value)}
                      className="mt-2"
                    />
                  </Box>
                </Box>
                <Box className="flex justify-end mt-3 gap-2">
                  <Box className="w-2/3">
                    <Typography>
                      <strong>Note:</strong> Here we offer you a chance to
                      suggest a fair price to the vendor, but please note that
                      we do not allow negotiation price drops to exceed 10% of
                      the initial offer. Vendors may stay firm on their rates.
                    </Typography>
                  </Box>
                  <Box className="flex gap-2">
                    <Button variant="contained" onClick={GoBackNego}>
                      Go Back
                    </Button>
                    <Button
                      variant="outlined"
                      color="warning"
                      onClick={handleNegociateOffer}
                    >
                      Negotiate Offer
                    </Button>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>
      <ScheduleCallModal
        isOpen={openCall}
        closeModal={() => setOpenCall(false)}
        msg={msg}
      />
      <CallDetailsModal
        isOpen={openDetails}
        closeModal={() => {
          setOpenDetails(false);
          setReSchedule(false);
          setMissedCall(false);
        }}
        msg={msg}
        reSchedule={reSchedule}
        setReSchedule={setReSchedule}
        missedCall={missedCall}
        setMissedCall={setMissedCall}
      />
    </>
  );
};

export default OfferDetailsModal;
